import { ref } from '@vue/composition-api'
import { STORE_MODULE_NAME } from "./contactWireStoreModule";

export default function useContactWire() {

    // Table Handlers
  const tableColumns = ref([
      { key: 'contact_wire',
        label: 'контактный провод',
      },
      { key: 'opora',
        label: 'опора',
      },
      { key: 'user',
        label: 'пользователь',
      },
  ])

  const setupData = {
      formModel: {
          number: '',
          object_type:'',
          opora: ''
      },
  }

  const addDataUrl = `${STORE_MODULE_NAME}/create`
  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`

  return {

    addDataUrl,
    fetchDataUrl,

    tableColumns,
    setupData,
  }
}
